import { Layout, Button } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { Component } from "react";
import { I18n } from "react-redux-i18n";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;

class AdvancedHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
    };
  }

  handleToggle = () => {
    this.setState(
      prevState => ({
        openMenu: !prevState.openMenu,
      }),
      () => {
        if (this.state.openMenu) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "auto";
        }
      }
    );
  };

  render() {
    const { openMenu } = this.state;
    return (
      <>
        <Header className="advanced-header">
          <div className="advanced-header__container">
            <img
              onClick={() => this.props.navigate(I18n.t("routes.login.url"))}
              src="/assets/svg/cpfl-logo.svg"
              className="advanced-header__logo"
              alt=""
            />
            <nav>
              <ul className={`advanced-header__menu ${openMenu ? "open" : ""}`}>
                <li className="advanced-header__menuItem">
                  <a
                    className="advanced-header__link"
                    rel="noopener noreferrer"
                    href="#quem-somos"
                  >
                    Quem somos
                  </a>
                </li>
                <li className="advanced-header__menuItem">
                  <a
                    className="advanced-header__link"
                    rel="noopener noreferrer"
                    href="#para-voce"
                  >
                    Para você
                  </a>
                </li>
                <li className="advanced-header__menuItem">
                  <a
                    className="advanced-header__link"
                    rel="noopener noreferrer"
                    href="#for-financeiras"
                  >
                    Para Financeiras
                  </a>
                </li>
                <li className="advanced-header__menuItem">
                  <a
                    className="advanced-header__link"
                    rel="noopener noreferrer"
                    href="#filantropia"
                  >
                    Filantropia
                  </a>
                </li>
                <li className="advanced-header__menuItem">
                  <a
                    className="advanced-header__link"
                    rel="noopener noreferrer"
                    href="#ajuda"
                  >
                    Ajuda
                  </a>
                </li>
              </ul>
            </nav>
            <Button
              type="text"
              icon={openMenu ? <CloseOutlined /> : <MenuOutlined />}
              onClick={this.handleToggle}
              className={`advanced-header__menuToggle ${openMenu ? "open" : ""}`}
            />
          </div>
        </Header>
      </>
    );
  }
}

const AdvancedHeaderWithNavigate = props => {
  const navigate = useNavigate();
  return <AdvancedHeader {...props} navigate={navigate} />;
};

export default AdvancedHeaderWithNavigate;
